<script>
    import {onDestroy, onMount} from "svelte"
    import LayoutGrid, {InnerGrid, Cell} from "@smui/layout-grid";
    import Button from "@smui/button";
    import Switch from "@smui/switch";
    import Textfield from "@smui/textfield";
    import FormField from "@smui/form-field";
    import Icon from "@smui/textfield/icon";
    import HelperText from "@smui/textfield/helper-text";
    import {Label} from "@smui/common";
    import CircularProgress from '@smui/circular-progress';
    import Select, {Option} from "@smui/select";
    import "svelte-material-ui/bare.css";

    import PageResult from "./PageResult.svelte";

    import {workingDays, globalState, api_url, api_url_public} from '../store/store.js';

    import {
        fillRequestData,
        isTrueInvoiceAmount,
        getSimulatorResults,
        setWantedTypes,
        resultIsAnnually,
        generateQRCodeWithLogo,
        transformWantedType,
        simplifyWantedType,
        getSimulator,
        getValidatedDate,
    } from "./Simple.js";


    export let API_URL;
    export let API_URL_PUBLIC;
    export let privateVersion = false;

    api_url.set(API_URL)
    api_url_public.set(API_URL_PUBLIC)

    let title = "Simulateur";
    if (privateVersion) {
        title = "Simulateur privé";
    }


    const wantedAmountTypes = setWantedTypes(privateVersion);
    $: promise = false;
    $: results = false;
    let hasTrueInvoiceAmount = false;

    let titleBase = "Simulation WeArePortage";
    let dynamicTitle = titleBase;

    // var used in input fields
    export let conventionalRuptureRateInput = 0;
    export let expensesAmountInput = null;
    export let hasHealthMutualInput = false;
    export let hasPaidVacationInput = false;
    export let operatingExpensesRateInput = 0;
    export let otherProvisionsRateInput = 0;
    export let pasRateInput = 0;
    export let portageFeesRateInput = 4.5;
    export let postalCode = "75002";
    export let wantedAmountInput = null;
    export let wantedAmountTypeInput = "TJM";
    export let workingDaysInput = 21;
    export let optimizeInput = false;
    export let forceOptimizeInput = false;
    export let firstNameInput = '';
    export let lastNameInput = '';
    export let dateInput = getValidatedDate(null);
    export let simulatorAllInput = false;
    export let simulatorMutualInput = true;
    export let simulatorVacationInput = false;

    let urlParams = new URLSearchParams(window.location.search);

    if (0 === urlParams.size) {
        const hash = window.location.hash;
        // "#/calculate?a=500&b=0..."

        const [path, queryString] = hash.split('?');
        urlParams = new URLSearchParams(queryString);
    }

    const forceOptimize = urlParams.get('force');
    const wanted = urlParams.get('a');
    const operating = urlParams.get('b');
    const rupture = urlParams.get('c');
    const expenses = urlParams.get('d');
    const provisions = urlParams.get('e');
    const pas = urlParams.get('f');
    const fees = urlParams.get('g');
    const days = urlParams.get('h');
    const wantedtype = urlParams.get('i');
    const postal = urlParams.get('j');
    const click = urlParams.get('k');
    const tabActive = urlParams.get('l');
    const optimize = urlParams.get('m');
    const date = urlParams.get('n');
    const firstName = urlParams.get('o');
    const lastName = urlParams.get('p');
    const simulatorAll = urlParams.get('q');
    const simulatorMutual = urlParams.get('r');
    const simulatorVacation = urlParams.get('s');

    export let clickParam = false;

    if (wanted) {
        wantedAmountInput = wanted;
    }
    if (rupture) {
        conventionalRuptureRateInput = rupture;
    }
    if (operating) {
        operatingExpensesRateInput = operating;
    }
    if (provisions) {
        otherProvisionsRateInput = provisions;
    }
    if (pas) {
        pasRateInput = pas;
    }
    if (fees) {
        portageFeesRateInput = fees;
    }
    if (days) {
        workingDaysInput = days;
    }
    if (wantedtype) {
        const wantedtypeTransform = transformWantedType(wantedtype);

        if (wantedAmountTypes.includes(wantedtypeTransform)) {
            wantedAmountTypeInput = wantedtypeTransform;
        }
    }
    if (postal) {
        postalCode = postal;
    }
    if ('1' === click) {
        clickParam = true;
    }
    if ('1' === forceOptimize) {
        forceOptimizeInput = true;
    }
    /*if('1' === optimize){
        optimizeInput = true;
    }*/
    if (date) {
        dateInput = getValidatedDate(date);
    }
    if (lastName) {
        lastNameInput = lastName;
    }

    if (firstName) {
        firstNameInput = firstName;
    }

    if (expenses) {
        expensesAmountInput = expenses;
    }

    /*if('1' === simulatorAll){
        simulatorAllInput = true;
    } else if('0' === simulatorAll){
        simulatorAllInput = false;
    }*/

    if ('1' === simulatorMutual) {
        simulatorMutualInput = true;
    } else if ('0' === simulatorMutual) {
        simulatorMutualInput = false;
    }

    if ('1' === simulatorVacation) {
        simulatorVacationInput = true;
    } else if ('0' === simulatorVacation) {
        simulatorVacationInput = false;
    }

    // Si la prop est vide ou non définie, on la remplace par le mois/année courant
    // let now = new Date();
    // let year = now.getFullYear();
    // let month = String(now.getMonth() + 1).padStart(2, "0");
    // let dateInter = parseInt(year+month);
    // console.log('dateInter', dateInter);

    //if (!dateInput) {
    //    dateInput = `${year}-${month}`; // ex. "2025-02"
    //}

    function changeGlobalStateSimulator() {
        globalState.update(state => ({
            ...state,
            q: simulatorAllInput ? 1 : 0,
            r: simulatorMutualInput ? 1 : 0,
            s: simulatorVacationInput ? 1 : 0,
        }));
    }

    let simAll = simulatorAllInput;
    let simMut = simulatorMutualInput;
    let simVac = simulatorVacationInput;

    function handleClick() {
        dynamicTitle = titleBase;
        let titleAdd = '';
        simAll = simulatorAllInput;
        simMut = simulatorMutualInput;
        simVac = simulatorVacationInput;

        if (lastNameInput) {
            titleAdd += ' ' + lastNameInput;
        }

        if (firstNameInput) {
            titleAdd += ' ' + firstNameInput;
        }

        if (expensesAmountInput && expensesAmountInput > 0) {
            titleAdd += ' Avfrais';
        } else {
            titleAdd += ' ssfrais';
        }

        if ('' !== titleAdd) {
            dynamicTitle += ' -' + titleAdd;
        }

        if (null === wantedAmountTypeInput || undefined === wantedAmountTypeInput) {
            wantedAmountTypeInput = 'TJM';
        }

        dateInput = getValidatedDate(dateInput);

        globalState.update(state => ({
            ...state,
            a: wantedAmountInput,
            c: conventionalRuptureRateInput,
            b: operatingExpensesRateInput,
            e: otherProvisionsRateInput,
            f: pasRateInput,
            g: portageFeesRateInput,
            h: workingDaysInput,
            i: simplifyWantedType(wantedAmountTypeInput),
            d: expensesAmountInput,
            j: postalCode,
            k: 1,
            l: tabActive,
            m: optimizeInput ? 1 : 0,
            n: dateInput,
            o: firstNameInput,
            p: lastNameInput,
            q: simulatorAllInput ? 1 : 0,
            r: simulatorMutualInput ? 1 : 0,
            s: simulatorVacationInput ? 1 : 0,
        }));

        let requestsData = fillRequestData(
            wantedAmountInput,
            conventionalRuptureRateInput,
            operatingExpensesRateInput,
            otherProvisionsRateInput,
            pasRateInput,
            portageFeesRateInput,
            workingDaysInput,
            wantedAmountTypeInput,
            expensesAmountInput,
            hasHealthMutualInput,
            hasPaidVacationInput,
            postalCode,
            dateInput,
        );
        hasTrueInvoiceAmount = isTrueInvoiceAmount(wantedAmountTypeInput);

        workingDays.set(workingDaysInput)

        promise = getSimulator(
            API_URL,
            requestsData,
            hasTrueInvoiceAmount,
            optimizeInput || forceOptimizeInput,
            simulatorAllInput,
            simulatorMutualInput,
            simulatorVacationInput,
        );

        promise.then((r) => {
            results = r;
        });
    }

    let optimisableStr = '';
    $: optimisableStr = wantedAmountTypeInput && (wantedAmountTypeInput.endsWith("annuel") || wantedAmountTypeInput.endsWith("annuelle"))
        ? " annuel"
        : "";

    /*let canvas1;
    let canvas2;
    let canvas3;
    let resizeObserver1;
    let resizeObserver2;
    let resizeObserver3;*/

    let currentVersion = null;

    async function checkVersion() {
        try {
            const res = await fetch('/version.json', {cache: 'no-store'});
            const data = await res.json();

            if (!currentVersion) {
                currentVersion = data.version;
            } else if (currentVersion !== data.version) {
                location.reload(true); // force rechargement complet
            }
        } catch (err) {
            console.error('Failed to check version.json', err);
        }
    }

    // Vérifie toutes les 5 minutes (300000 ms)
    // Vérifie toutes les 1 minute (60000 ms)
    setInterval(checkVersion, 60000);

    // Et vérifie dès le début aussi
    checkVersion();

    onMount(() => {
        /*generateQRCodeWithLogo(canvas1, "/ascalium-logo.png", "https://www.ascalium.com");
        generateQRCodeWithLogo(canvas2, "/wearefreelance-logo.png", "https://www.wearefreelance.fr/");
        generateQRCodeWithLogo(canvas3, "/weareportage-logo.png", "https://www.weareportage.fr/");


        resizeObserver1 = new ResizeObserver(() => {
            generateQRCodeWithLogo(canvas1, "/ascalium-logo.png", "https://www.ascalium.com");
        });
        resizeObserver2 = new ResizeObserver(() => {
            generateQRCodeWithLogo(canvas2, "/wearefreelance-logo.png", "https://www.wearefreelance.fr/");
        });
        resizeObserver3 = new ResizeObserver(() => {
            generateQRCodeWithLogo(canvas3, "/weareportage-logo.png", "https://www.weareportage.fr/");
        });

        if (canvas1) {
            resizeObserver1.observe(canvas1);
        }
        if (canvas2) {
            resizeObserver1.observe(canvas2);
        }
        if (canvas3) {
            resizeObserver1.observe(canvas3);
        }*/

        if (clickParam) {
            handleClick();
        }
    });

    onDestroy(() => {
        /*if (resizeObserver1 && canvas1) {
            resizeObserver1.unobserve(canvas1);
        }
        if (resizeObserver2 && canvas2) {
            resizeObserver2.unobserve(canvas2);
        }
        if (resizeObserver3 && canvas3) {
            resizeObserver3.unobserve(canvas3);
        }*/
    });

    //RAISONNABLE
    //15% de la facturation global
    //ou 30% du salaire brut
    //Ou 40% du salaire net
</script>

<svelte:head>
    <title>{dynamicTitle}</title>
</svelte:head>

<main>
    <div class="watermark"></div>
    <div id="watermark-pdf">
        <img alt="simulation" src="/static/watermark.png"
             style="position: absolute;bottom:25%;left:1cm;transform:rotate(-30deg);opacity:0.15;width:23cm;z-index:10;"/>
    </div>
    <header>
        <div class="logo" style="margin: auto 0;">
            <img src="/static/wap-logo.svg" alt="logo WeArePortage"/>
        </div>
        <h2 class="blue-weare" style="margin: auto 0;">{title}</h2>
    </header>
    <div class="columns margins">
        <!--<LayoutGrid class="resume-salary">
            <Cell span={12}><h1>QR Code avec logo BIS</h1></Cell>
            <Cell span={4}>
                <div style="width: auto;height: 300px;">
                <canvas bind:this={canvas1}></canvas>
                </div>
            </Cell>
            <Cell span={4}>
                <div style="width: auto;height: 300px;">
                <canvas bind:this={canvas2}></canvas>
                </div>
            </Cell>
            <Cell span={4}>
                <div style="width: auto;height: 300px;">
                <canvas bind:this={canvas3}></canvas>
                </div>
            </Cell>
        </LayoutGrid>-->
        <!--<LayoutGrid class="resume-salary">
            <Cell>
                <div>Que souhaitez-vous avoir ?</div>
            </Cell>
            <Cell span={12}>
                <Set
                    chips={wantedAmountTypes}
                    let:chip
                    choice
                    bind:selected={wantedAmountTypeInput}>
                    <Chip {chip}>
                        <Text>{chip}</Text>
                    </Chip>
                </Set>
            </Cell>
        </LayoutGrid>-->
        <LayoutGrid class="resume-salary">
            <Cell span={3} spanDevices={{ phone: 12 }}>
                <Select
                        style="width: 100%;"
                        variant="outlined"
                        bind:value={wantedAmountTypeInput}
                        label="Type de rémunération">
                    {#each wantedAmountTypes as wanted}
                        <Option value={wanted}>{wanted}</Option>
                    {/each}
                </Select>
            </Cell>
            <Cell span={3} spanDevices={{ phone: 12 }}>
                <Textfield
                        style="width: 100%;"
                        helperLine$style="width: 100%;"
                        variant="outlined"
                        bind:value={wantedAmountInput}
                        label={wantedAmountTypeInput}>
                    <Icon class="material-icons" slot="trailingIcon">euro</Icon>
                    <HelperText slot="helper">
                        Montant {wantedAmountTypeInput} souhaité en €
                    </HelperText>
                </Textfield>
            </Cell>
            <Cell span={3} spanDevices={{ phone: 12 }}>
                <Textfield
                        style="width: 100%;"
                        helperLine$style="width: 100%;"
                        variant="outlined"
                        bind:value={expensesAmountInput}
                        label="Frais optimisables {optimisableStr}">
                    <Icon class="material-icons" slot="trailingIcon">euro</Icon>
                    <HelperText slot="helper">
                        Montant des frais optimisables {optimisableStr} en €
                    </HelperText>
                </Textfield>
            </Cell>
            <Cell span={3} spanDevices={{ phone: 12 }}>
                <Textfield
                        style="width: 100%;"
                        helperLine$style="width: 100%;"
                        variant="outlined"
                        bind:value={postalCode}
                        label="Code postal">
                    <Icon class="material-icons" slot="trailingIcon">location_city</Icon>
                    <HelperText slot="helper">Code postal de la mission</HelperText>
                </Textfield>
            </Cell>

        </LayoutGrid>

        <LayoutGrid class="options resume-salary">
            <Cell span="12">
                <div>Options</div>
            </Cell>
            <Cell span={4} spanDevices={{ phone: 12 }}>
                <Textfield
                        style="width: 100%;"
                        variant="outlined"
                        bind:value={dateInput}
                        label="Mois/Année"
                        type="month"
                >
                    <Icon class="material-icons" slot="trailingIcon">event</Icon>
                </Textfield>
            </Cell>
            <Cell span={4} spanDevices={{ phone: 12 }}>
                <Textfield
                        style="width: 100%;"
                        variant="outlined"
                        bind:value={firstNameInput}
                        label="Prénom">
                    <Icon class="material-icons" slot="trailingIcon">person</Icon>
                </Textfield>
            </Cell>
            <Cell span={4} spanDevices={{ phone: 12 }}>
                <Textfield
                        style="width: 100%;"
                        variant="outlined"
                        bind:value={lastNameInput}
                        label="Nom">
                    <Icon class="material-icons" slot="trailingIcon">person</Icon>
                </Textfield>
            </Cell>
            <Cell span={2} spanDevices={{ phone: 12 }}>
                <Textfield
                        variant="outlined"
                        bind:value={workingDaysInput}
                        maxlength="2"
                        label="Nombre de jours travaillés">
                    <Icon class="material-icons" slot="trailingIcon">event</Icon>
                    <HelperText slot="helper">
                        Nombre de jours travaillés
                    </HelperText>
                </Textfield>
            </Cell>
            <Cell span={2} spanDevices={{ phone: 12 }}>
                <Textfield
                        variant="outlined"
                        bind:value={portageFeesRateInput}
                        label="Commission de portage">
                    <Icon class="material-icons" slot="trailingIcon">percent</Icon>
                    <HelperText slot="helper">Commission de portage</HelperText>
                </Textfield>
            </Cell>
            <Cell span={2} spanDevices={{ phone: 12 }}>
                <Textfield
                        variant="outlined"
                        bind:value={conventionalRuptureRateInput}
                        label="Rupture conventionnelle">
                    <Icon class="material-icons" slot="trailingIcon">percent</Icon>
                    <HelperText slot="helper">Rupture conventionnelle</HelperText>
                </Textfield>
            </Cell>
            {#if privateVersion}
                <Cell span={2} spanDevices={{ phone: 12 }}>
                    <Textfield
                            variant="outlined"
                            bind:value={operatingExpensesRateInput}
                            label="Frais de fonctionnement">
                        <Icon class="material-icons" slot="trailingIcon">percent</Icon>
                        <HelperText slot="helper">Frais de fonctionnement</HelperText>
                    </Textfield>
                </Cell>
            {/if}
            <Cell span={2} spanDevices={{ phone: 12 }}>
                <Textfield
                        variant="outlined"
                        bind:value={otherProvisionsRateInput}
                        label="Provisions">
                    <Icon class="material-icons" slot="trailingIcon">percent</Icon>
                    <HelperText slot="helper">Provisions</HelperText>
                </Textfield>
            </Cell>

            <Cell span={2} spanDevices={{ phone: 12 }}>
                <Textfield
                        variant="outlined"
                        bind:value={pasRateInput}
                        label="PAS">
                    <Icon class="material-icons" slot="trailingIcon">percent</Icon>
                    <HelperText slot="helper">Prélèvement à la source</HelperText>
                </Textfield>
            </Cell>
            <!--<Cell span={3} spanDevices={{ phone: 12 }}>
                <FormField align="end">
                    <Switch bind:checked={simulatorAllInput} />
                    <span slot="label">
                        {#if simulatorAllInput}
                            Toutes les simulations
                        {:else}
                            1 simulation
                        {/if}
                    </span>
                </FormField>
            </Cell>
            <Cell span={3} spanDevices={{ phone: 12 }}>
                <FormField align="end" bind:value={wantedAmountInput}>
                    <Switch bind:checked={optimizeInput}/>
                    <span slot="label">Optimisation par TJM</span>
                    <Wrapper rich>
                        <Label> ? </Label>
                        <Tooltip>
                            <Content>
                                Optimisation sur la base du résultat: <br />
                                Sans mutuelle, Sans Congés payés, Sans Frais
                            </Content>
                        </Tooltip>
                    </Wrapper>
                </FormField>
            </Cell>-->

        </LayoutGrid>
        <LayoutGrid class="resume-salary"></LayoutGrid>

        <LayoutGrid class="options resume-salary" style="justify-content: center;">
            {#if !simulatorAllInput}
                <Cell span={3} spanDevices={{ phone: 0 }}></Cell>
                <Cell span={3} spanDevices={{ phone: 12 }}>
                    <FormField align="end">
                        <Switch bind:checked={simulatorMutualInput} disabled={simulatorAllInput}/>
                        <span slot="label" style="font-weight: bold;">
                            {#if simulatorMutualInput}
                                Avec Mutuelle employeur
                            {:else}
                                Sans Mutuelle employeur
                            {/if}
                        </span>
                    </FormField>
                </Cell>
                <Cell span={3} spanDevices={{ phone: 12 }}>
                    <FormField align="end">
                        <Switch bind:checked={simulatorVacationInput} disabled={simulatorAllInput}/>
                        <span slot="label" style="font-weight: bold;">
                            {#if simulatorVacationInput}
                                Avec Congés payés
                            {:else}
                                Sans Congés payés
                            {/if}
                        </span>
                    </FormField>
                </Cell>
            {/if}
        </LayoutGrid>


        <LayoutGrid>
            <Cell span={12} class="resume-salary" style="justify-content: center;text-align: center;">
                <Button
                        on:click={handleClick}
                        disabled={!wantedAmountInput}
                        variant="raised" style="width: 60%;">
                    <Label>Simuler</Label>
                </Button>
            </Cell>
            {#await promise}
                <Cell span={12}>
                    <div style="display: flex; justify-content: center">
                        <CircularProgress style="height: 32px; width: 32px;" indeterminate/>
                    </div>
                </Cell>
            {:then results}
                {#if results}
                    <Cell span={12} class="resume-salary">
                        <h2>Résultat du simulateur</h2>
                    </Cell>
                    <Cell span={12}>
                        <PageResult
                                {results}
                                {privateVersion}
                                {hasTrueInvoiceAmount}
                                {simAll}
                                {simMut}
                                {simVac}
                        />
                    </Cell>
                {/if}
            {:catch error}
                <p style="color: red">{error.message}</p>
            {/await}
        </LayoutGrid>
    </div>
    <div class="no-web">
        Cette simulation a été réalisée pour donner à l'adhérent une estimation de sa rémunération sur la base d'une
        facturation. Cette simulation, avant prélèvements sociaux, ne revêt aucune valeur contractuelle.
    </div>
    <div class="download">
        Cette simulation a été réalisée pour donner à l'adhérent une estimation de sa rémunération sur la base d'une
        facturation. Cette simulation, avant prélèvements sociaux, ne revêt aucune valeur contractuelle.
    </div>
</main>

<style>
    main {
        max-width: 1300px;
        margin: auto;
        font-family: sans-serif;
    }

    header {
        display: flex;
        height: 100px;
        gap: 20px;
        flex-wrap: wrap;
    }

    .logo {
        max-width: 200px;
        min-width: 200px;
    }

    @media (max-width: 500px) {
        .logo {
            max-width: 100px; /* Encore plus petit pour les très petits écrans */
            min-width: 100px;
        }
    }

    h1, .blue-weare {
        color: #023864;
    }

    :global(.no-web) {
        visibility: hidden;
        display: none;
    }

    :global(.watermark) {
        background-image: url('/static/watermark.svg');
        background-repeat: no-repeat;
        visibility: hidden;
    }

    :global(#watermark-pdf) {
        visibility: hidden;
    }

    :global(canvas) {
        width: 100%;
        height: auto;
        display: block;
    }

    @media print {
        header {
            display: none;
        }

        @page {
            size: A4;   /* auto is the initial value */
            margin: 0.25cm 0.25cm;  /* this affects the margin in the printer settings */
        }

        :global(html) {
            font-size: 9pt;
            font-family: serif;
        }

        :global(.mdc-data-table) {
            background-color: transparent;
        }

        :global(.watermark) {
            visibility: visible;
            height: 4cm;
            width: 20cm;
            top: 50%;
            position: absolute;
            transform: rotate(-30deg);
            background-image: url('/static/watermark.svg');
            background-repeat: no-repeat;
            background-size: 80%;
            background-position: 50%;
            z-index: 10;
            opacity: 15%;
        }

        :global(.no-web) {
            visibility: visible;
            display: block;
        }

        :global(.resume-salary) {
            visibility: hidden;
            display: none;
            border: 0;
            padding: 0;
        }
    }

    :global(.download) {
        visibility: hidden;
        display: none;
        border: 0;
        padding: 0;
    }

    :global(.pdf-export) {
        width: 25cm; /* auto is the initial value */
        margin: 0;
        padding: 0;
        font-size: 9pt;
        font-family: sans-serif;
    }

    :global(.pdf-export .resume-salary) {
        visibility: hidden;
        display: none;
        border: 0;
        padding: 0;
    }

    :global(.pdf-export .no-web) {
        visibility: hidden;
        display: none;
        border: 0;
        padding: 0;
    }

    :global(.pdf-export .download) {
        visibility: visible;
        display: block;
    }

    :global(.pdf-export .no-download) {
        visibility: hidden;
        display: none;
        border: 0;
        padding: 0;
    }

    :global(.pdf-export header) {
        display: none;
    }

    :global(.pdf-export h2) {
        display: none;
    }

    :global(.pdf-export #watermark-pdf) {
        display: block !important;
        visibility: visible;
    }

    /*:global(.pdf-export main) {
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    :global(.pdf-export .mdc-data-table) {
        width: 100% !important;
        overflow: visible !important;
        table-layout: auto !important;
    }*/


    /*
         main {
         text-align: center;
         padding: 1em;
         max-width: 240px;
         margin: 0 auto;
         }

         h1 {
         color: #ff3e00;
         text-transform: uppercase;
         font-size: 4em;
         font-weight: 100;
         }

         @media (min-width: 640px) {
         main {
         max-width: none;
         }
        } */
</style>
